import { Component } from '@angular/core';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';

@Component({
  selector: 'app-renouvellement-accepted-dialog',
  standalone: true,
  imports: [OuiDialogModule, OuiButton, OuiIconModule],
  templateUrl: './renouvellement-accepted-dialog.component.html',
  styleUrl: './renouvellement-accepted-dialog.component.scss',
})
export class RenouvellementAcceptedDialogComponent {}
